<div class="reactions-container">
  <span class="reactions-description">{{ 'available_reactions' | translate }}</span>
  <mat-divider></mat-divider>
  <div class="reactions-panel">
    @for (item of availableReactions; track item) {
      <span class="reaction-item" (click)="changeReaction(item)">
        {{ item.emoji }}
      </span>
    }
  </div>
</div>
